/** Reusable ground scenery. These silhouettes are decorative, not collision surfaces.
 * Primary/shade color the main body, wood/woodEdge bark and reeds, stone the
 * footing, glass/glassCore mineral, spore, or weathered inscription accents.
 * Dimensions describe an unscaled frame whose bottom is the ground anchor.
 */
export const WORLD_PROP_TEMPLATES = {
  layered_outcrop: { kind: 'moor_stone', name: 'Layered stone outcrop', frame: { w: 144, h: 88 }, band: 'vegetation' },
  crystal_cluster: { kind: 'moor_stone', name: 'Faceted crystal cluster', frame: { w: 100, h: 124 }, band: 'vegetation' },
  frost_shards: { kind: 'moor_stone', name: 'Wind-carved frost shards', frame: { w: 124, h: 116 }, band: 'vegetation' },
  desert_cairn: { kind: 'moor_stone', name: 'Weathered desert cairn', frame: { w: 96, h: 120 }, band: 'vegetation' },
  moss_log: { kind: 'fallen_log', name: 'Moss-covered fallen log', frame: { w: 176, h: 72 }, band: 'vegetation' },
  root_bridge: { kind: 'fallen_log', name: 'Interwoven root arch', frame: { w: 224, h: 104 }, band: 'vegetation' },
  ruin_arch: { kind: 'gate', name: 'Weathered ruin arch', frame: { w: 176, h: 200 }, band: 'vegetation' },
  standing_stones: { kind: 'broken_pillar', name: 'Carved standing stones', frame: { w: 144, h: 152 }, band: 'vegetation' },
  giant_mushroom: { kind: 'bioluminescent_fungus', name: 'Giant shelf mushroom', frame: { w: 132, h: 156 }, band: 'vegetation' },
  reed_bed: { kind: 'dead_bracken', name: 'Wind-bent reed bed', frame: { w: 128, h: 112 }, band: 'vegetation' },
} as const;

export type WorldPropTemplate = keyof typeof WORLD_PROP_TEMPLATES;
